/* THE HANDY MOM - modern polish pack (arrows + scroll reveal + shine + promo) */
(function () {
  'use strict';

  var CTA_SEL = 'a.thm-btn, a.thm-btn2, .thm-cta2 a, a.button, button.button';

  /* ---- 1. wrap trailing arrow of CTAs so it can slide on hover ---- */
  function wrapArrows() {
    document.querySelectorAll(CTA_SEL).forEach(function (el) {
      if (el.querySelector('.thm-arr')) return;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var last = null, n;
      while ((n = walker.nextNode())) { if (n.nodeValue.trim()) last = n; }
      if (!last) return;
      var m = last.nodeValue.match(/^(.*?)(→|➔|➤)\s*$/);
      if (!m) return;
      last.nodeValue = m[1];
      var span = document.createElement('span');
      span.className = 'thm-arr';
      span.textContent = m[2];
      last.parentNode.insertBefore(span, last.nextSibling);
    });
  }

  /* ---- 2. reveal on scroll with stagger ---- */
  function setupReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var groups = [
      '.thm-trust > div',
      '.thm-how__card, .thm2-how__card',
      '.thm-q, .thm2-rev__card',
      '#MainContent .grid--peek .grid__item, #MainContent .product-grid .grid__item',
      '.collapsible-content details',
    ];
    var singles = [
      '.thm-hero__txt', '.thm-hero__img',
      '.thm-how h2', '.thm-quotes h2', '.thm2-how h2', '.thm2-rev__head',
      '#MainContent .title-wrapper-with-link',
      '.collapsible-content__heading',
      '.thm-cta2', '.thm2-cta__in',
    ];

    var targets = [];
    groups.forEach(function (sel) {
      var els = document.querySelectorAll(sel);
      var byParent = new Map();
      els.forEach(function (el) {
        var list = byParent.get(el.parentNode) || [];
        list.push(el);
        byParent.set(el.parentNode, list);
      });
      byParent.forEach(function (list) {
        list.forEach(function (el, i) {
          el.style.setProperty('--thm-d', (i * 0.09).toFixed(2) + 's');
          targets.push(el);
        });
      });
    });
    singles.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { targets.push(el); });
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('thm-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

    targets.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.85 && r.bottom > 0) {
        el.classList.add('thm-reveal');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { el.classList.add('thm-in'); });
        });
      } else {
        el.classList.add('thm-reveal');
        io.observe(el);
      }
    });
  }

  /* ---- 3. shine sweep overlay on buttons ---- */
  function addShine() {
    document.querySelectorAll(CTA_SEL).forEach(function (el) {
      if (el.querySelector('.thm-shine')) return;
      var s = document.createElement('span');
      s.className = 'thm-shine';
      s.setAttribute('aria-hidden', 'true');
      el.appendChild(s);
    });
  }

  /* ---- 4. sale promo : -XX% badge + "You save" line (auto-computed) ---- */
  function addPromo() {
    document.querySelectorAll('.product-card-wrapper').forEach(function (card) {
      if (card.querySelector('.thm-pct')) return;
      var reg = card.querySelector('s.price-item--regular');
      var sale = card.querySelector('.price-item--sale');
      if (!reg || !sale) return;
      var num = function (t) {
        var m = t.replace(/\s/g, '').match(/(\d+(?:[.,]\d+)?)/);
        return m ? parseFloat(m[1].replace(',', '.')) : NaN;
      };
      var rv = num(reg.textContent), sv = num(sale.textContent);
      if (!(rv > sv) || !isFinite(rv) || !isFinite(sv)) return;
      var pct = Math.round((1 - sv / rv) * 100);
      var saving = (rv - sv).toFixed(2);
      var inner = card.querySelector('.card__inner') || card.querySelector('.card__media');
      if (inner) {
        var b = document.createElement('span');
        b.className = 'thm-pct';
        b.textContent = '-' + pct + '%';
        inner.appendChild(b);
      }
      var priceBox = card.querySelector('.price');
      if (priceBox && !card.querySelector('.thm-save')) {
        var m = sale.textContent.match(/(\d+(?:[.,]\d+)?)/);
        var savingTxt = m ? sale.textContent.trim().replace(m[1], saving) : saving;
        var s = document.createElement('span');
        s.className = 'thm-save';
        s.textContent = 'You save ' + savingTxt;
        priceBox.appendChild(s);
      }
    });
  }

  function init() { wrapArrows(); addShine(); setupReveal(); addPromo(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
